import React from "react";
import { Button } from "../../components/ui/button";
import { RefreshCw, LogOut, BarChart3, KeyRound, UserCircle2 } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "../../components/ui/dropdown-menu";

function ltpStatusLabel({ cacheDate, lastFetch, fetching }) {
  let base = "not fetched";
  if (cacheDate) base = `cached ${cacheDate}`;
  else if (lastFetch) base = lastFetch.toLocaleTimeString("en-IN", { hour12: false });
  return `LTPs · ${base}${fetching ? " · updating…" : ""}`;
}

export default function Header({ user, priceState, onRefresh, onChangePassword, onLogout }) {
  return (
    <header className="border-b border-[#27272A] bg-[#08080A] sticky top-0 z-20">
      <div className="px-4 sm:px-6 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="h-7 w-7 bg-[#007AFF] flex items-center justify-center rounded-sm">
            <BarChart3 className="h-3.5 w-3.5 text-white" />
          </div>
          <div>
            <div className="text-xs tracking-[0.25em] uppercase font-semibold">Trade Monitor</div>
            <div className="text-[10px] text-[#71717A] num" data-testid="ltp-status">{ltpStatusLabel(priceState)}</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button data-testid="refresh-prices" variant="outline" size="sm" onClick={onRefresh} disabled={priceState.fetching}
            className="bg-transparent border-[#27272A] text-[#A1A1AA] hover:bg-[#1A1B23] hover:text-white rounded-sm">
            <RefreshCw className={`h-3.5 w-3.5 ${priceState.fetching ? "animate-spin" : ""}`} />
            <span className="hidden sm:inline ml-2 text-xs">Refresh LTPs</span>
          </Button>
          <div className="hidden sm:block text-xs text-[#A1A1AA] px-3 border-l border-[#27272A]">{user?.email}</div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button data-testid="user-menu-btn" variant="ghost" size="sm" className="text-[#A1A1AA] hover:text-white hover:bg-[#1A1B23] rounded-sm">
                <UserCircle2 className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-[#121318] border-[#27272A] text-white rounded-sm min-w-[180px]" data-testid="user-menu">
              <DropdownMenuLabel className="text-[10px] tracking-[0.2em] uppercase text-[#71717A] font-normal">{user?.email}</DropdownMenuLabel>
              <DropdownMenuSeparator className="bg-[#27272A]" />
              <DropdownMenuItem data-testid="menu-change-password" onSelect={onChangePassword} className="cursor-pointer text-xs focus:bg-[#1A1B23] focus:text-white">
                <KeyRound className="h-3.5 w-3.5 mr-2" /> Change Password
              </DropdownMenuItem>
              <DropdownMenuSeparator className="bg-[#27272A]" />
              <DropdownMenuItem data-testid="menu-logout" onSelect={onLogout} className="cursor-pointer text-xs text-[#FF3B30] focus:bg-[#FF3B30]/10 focus:text-[#FF3B30]">
                <LogOut className="h-3.5 w-3.5 mr-2" /> Sign Out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
